<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'labels', 'tooltip'],
  mounted() {
    this.renderLineChart();
  },
  computed: {
    chartData: function() {
      return this.data;
    }
  },
  methods: {
    renderLineChart: function() {
        this.renderChart({
        labels: this.labels,
        datasets: [
            {
            label: this.tooltip,
            backgroundColor: '#448aff',
            data: this.data
            }
        ]
        })
    }
  },
  watch: {
    data: function() {
      this.renderLineChart();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LineChart.vue